import { render, staticRenderFns } from "./releaseDetail.vue?vue&type=template&id=4e96a822&"
import script from "./releaseDetail.vue?vue&type=script&lang=js&"
export * from "./releaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports